import { render, staticRenderFns } from "./DepositLegacy.vue?vue&type=template&id=449fe014&scoped=true"
import script from "./DepositLegacy.vue?vue&type=script&lang=js"
export * from "./DepositLegacy.vue?vue&type=script&lang=js"
import style0 from "./DepositLegacy.vue?vue&type=style&index=0&id=449fe014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449fe014",
  null
  
)

export default component.exports